import { Request } from '../request'

// 登录
export function getFaq():any {
  return Request.axiosInstance({
    url: '/faqs',
    method: 'get'
  })
}
